import React, { useCallback } from 'react'
import { BaseBlockquotePlugin } from '@udecode/plate-block-quote'
import { collapseSelection } from '@udecode/plate-common'
import { useEditorRef, useEditorSelector } from '@udecode/plate-common/react'
import { BoxProps, IconButton } from '@ui'

import { isBlockquoteElement } from '../../utils/helpers'

type Props = {
    background?: BoxProps['background']
}

export const BlockQuoteToolbarButton = ({ background }: Props) => {
    const editor = useEditorRef()

    const isBlockQuoteActive = useEditorSelector((_editor) => {
        return isBlockquoteElement(_editor)
    }, [])

    const onClick = useCallback(() => {
        editor.tf.toggle.block({ type: BaseBlockquotePlugin.key })
        collapseSelection(editor)
    }, [editor])

    return (
        <IconButton
            opaque
            active={isBlockQuoteActive}
            icon="blockquote"
            background={isBlockQuoteActive ? 'level3' : background}
            tooltip="Block quote"
            tooltipOptions={{ placement: 'vertical', immediate: true }}
            onClick={onClick}
        />
    )
}
